/*
  Promo strip (sections/Custom-promo-strip.liquid). The section wrapper is
  position: sticky in CSS; this only keeps it just below the sticky header and
  marks it as stuck. Nothing here changes the layout, so no layout shift.
*/
(function () {
  if (window.__promoStripStickyInit) return;
  window.__promoStripStickyInit = true;

  function getHeaderHeight() {
    var header = document.getElementById('header');
    return header ? header.offsetHeight : 0;
  }

  function init() {
    var strips = document.querySelectorAll('[data-promo-strip]');
    if (!strips.length) return;

    var wrappers = [];
    for (var i = 0; i < strips.length; i++) {
      var wrapper = strips[i].closest('.shopify-section') || strips[i];
      wrappers.push({ wrapper: wrapper, strip: strips[i] });
    }

    function setTop() {
      var top = getHeaderHeight();
      for (var j = 0; j < wrappers.length; j++) wrappers[j].wrapper.style.top = top + 'px';
    }

    function onScroll() {
      var top = getHeaderHeight();
      for (var j = 0; j < wrappers.length; j++) {
        var rect = wrappers[j].wrapper.getBoundingClientRect();
        wrappers[j].strip.classList.toggle('promo-strip--stuck', window.pageYOffset > 0 && rect.top <= top + 1);
      }
    }

    setTop();
    onScroll();
    window.addEventListener('load', setTop);
    window.addEventListener('resize', setTop);
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
